export enum HcPortalEnv {
  Dev = 'human-capital-portal-dev',
  Prod = 'human-capital-portal-prod',
}

export interface LoginRequest {
  envName: HcPortalEnv
}

export interface ImpersonateUserRequest {
  envName: HcPortalEnv
  username: string
}

export interface VerifyTokenResponse {
  valid: boolean
}

export interface LoginResponse {
  data: {
    envName: HcPortalEnv
    accessToken: string
  }
}

export type ModuleFunction = {
  moduleName: 'assume-identity'
  functionName: 'assume-user' | & string
} |{
  moduleName: 'human-capital-portal'
  functionName: 'access-portal' | 'read-portal-configuration' | 'edit-portal-configuration' | 'run-data-migrations' | 'read-write-checklist' | & string
} | {
  moduleName: 'employee-data'
  functionName: 'view-employee-details' | 'view-buying-power' | 'export-all-employee-data'
    | 'access-australia' | 'access-china' | 'access-hong-kong' | 'access-india' | 'access-japan' | 'access-korea' | 'access-singapore' | 'access-taiwan' | 'access-united-kingdom' | 'access-united-states'
    | 'manage-country-australia' | 'manage-country-china' | 'manage-country-hong-kong' | 'manage-country-india' | 'manage-country-japan' | 'manage-country-korea' | 'manage-country-singapore' | 'manage-country-taiwan' | 'manage-country-united-kingdom' | 'manage-country-united-states'
    | 'access-compensation-section' | 'access-personal-info-section' | 'access-pm-info-section' | 'access-annual-performance-section'
    | 'access-reward-exercise' | 'manage-reward-exercise' | 'manage-reward-exercise-budget' | 'manage-reward-exercise-all'
    | 'manage-probation-record'
    | 'manage-time-off-configuration' & string
} | {
  moduleName: 'document-autofill'
  functionName: 'create-contract' | 'create-term-sheet' | & string
} | {
  moduleName: 'headcount'
  functionName: 'download-general-headcount-report' | 'download-current-employee-headcount-report' | & string
} | {
  moduleName: 'staff-cost'
  functionName: 'import-vendor-cost-report' | 'export-annual-staff-cost-data'
    | 'download-fund-cost-report' | 'download-salary-history-report' | 'download-headcount-passthrough-report' | & string
} | {
  moduleName: 'appraisal'
  functionName: 'manage-appraisal-events' | 'manage-appraisal-goals' | & string
}

export interface AuthPayload {
  env: string
  roles: string []
  exp: number,
  aud: string,
  iss: string,
  sub: string,
}

export interface User {
  name: string
  roles: string[]
  env: string
  exp: number
  token: string
}

export interface AuthState {
  user?: User
  permissions?: ModuleFunction[]
  impersonatedUsername?: string
}
